export default function FeedbackAndSupport() {
  return (
    <div>
      <h1>Feedback And Support</h1>
    </div>
  );
}
